export default process.env.NODE_ENV === 'production' ?
{
  apiBaseUrl: 'https://api.hardypress.com',
  stripeKey: 'pk_live_OxciP2IQwiy5501OBgnzP6Kv',
  pusher: {
    apiKey: 'fd5a1f0ac75bf2dda1d3',
    cluster: 'eu',
  },
}
:
{
  apiBaseUrl: 'http://localhost:3000',
  // apiBaseUrl: 'https://hardypress-api-24-672f35dc6193.herokuapp.com',
  stripeKey: 'pk_test_RBLgzzji0vShgNYZoctoeVwS',
  pusher: {
    apiKey: 'c517356e55009d550d1f',
    cluster: 'eu',
  },
};




// WEBPACK FOOTER //
// ./app/config.js